<script setup lang="ts">
import PostSubmitSuccessPanel from '@/components/current-student-advanced-standing-form/submission/PostSubmitSuccessPanel.vue'
import SubmitActionPanel from '@/components/current-student-advanced-standing-form/submission/SubmitActionPanel.vue'
import type { LegacyClassBinding } from '@/components/current-student-advanced-standing-form/shared/types'

defineProps<{
  applicationComplete: boolean
  agreementChecked: boolean
  progressVisible: boolean
  progressClass: LegacyClassBinding
  progressMessage: string
  errorMessage: string
  buttonText: string
  buttonDisabled: boolean
  referenceCode: string
}>()

const emit = defineEmits<{
  'update:agreementChecked': [checked: boolean]
  submit: []
}>()
</script>

<template>
  <fieldset id="submitApplicationDiv">
    <template v-if="!applicationComplete">
      <SubmitActionPanel
        :agreement-checked="agreementChecked"
        :progress-visible="progressVisible"
        :progress-class="progressClass"
        :progress-message="progressMessage"
        :error-message="errorMessage"
        :button-text="buttonText"
        :button-disabled="buttonDisabled"
        @update:agreement-checked="emit('update:agreementChecked', $event)"
        @submit="emit('submit')"
      />
    </template>
  </fieldset>
  <PostSubmitSuccessPanel
    :visible="applicationComplete"
    :reference-code="referenceCode"
  />
</template>
